import React from "react";
import Button from "antd/lib/button";
import Popover from "antd/lib/popover";
import List from "antd/lib/list";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Row, Col } from "react-bootstrap";
import Texty from "rc-texty";
import "rc-texty/assets/index.css";
const PassList = ({ passArr, pass }) => {
  let color = passColor(pass.length);
  const PopUp=(
      <p>Скопировать</p>
      );
  let style = { borderColor: color };
  const ListPass = (
    <>
      <Row>
        <Col xsHidden>
          <List.Item size="large" style={style} key={pass}>
            <Texty enter={getEnter} style={{ fontSize: "3.8rem" }}>
              {pass}
            </Texty>
          </List.Item>
          <List.Item style={{ border: "0" }} />
        </Col>
      </Row>
    </>
  );
  const ListItem = passArr.map(item => {
    let color = passColor(item.length);
    let style = { borderBottom: `1px solid ${color}` };
    return (
      <CopyToClipboard key={item} text={item}>
        <List.Item
          style={style}
          actions={[
            <Popover content={PopUp} placement='left'>            <Button type="primary" shape="circle" icon="copy" size={"small"} /></Popover>

          ]}
          key={item}
        >
          <Texty enter={getEnter}>{item}</Texty>
        </List.Item>
      </CopyToClipboard>
    );
  });
  return (
    <List>
      {ListPass}
      {ListItem}
    </List>
  );
};

export default PassList;

const getEnter = e => {
  switch (e.index) {
    case 0:
      return {
        rotate: 90,
        opacity: 0,
        y: -60
      };
    case 10:
    case 1:
      return {
        y: -60,
        x: -10,
        opacity: 0
      };
    case 9:
    case 2:
      return {
        y: -60,
        x: 20,
        opacity: 0
      };
    case 3:
      return {
        y: 60,
        opacity: 0
      };
    case 8:
    case 4:
      return {
        x: 30,
        opacity: 0
      };
    case 5:
      return {
        enter: [
          {
            scale: 2,
            opacity: 0,
            type: "set"
          },
          { scale: 1.2, opacity: 1, duration: 300 },
          { scale: 0.9, duration: 200 },
          { scale: 1.05, duration: 150 },
          { scale: 1, duration: 100 }
        ],
        leave: {
          opacity: 0,
          scale: 0
        }
      };
    case 6:
      return {
        scale: 0.8,
        x: 30,
        y: -10,
        opacity: 0
      };
    case 7:
      return {
        scale: 0.8,
        x: 30,
        y: 10,
        opacity: 0
      };
    default:
      return {
        opacity: 0
      };
  }
};

function passColor(length) {
  if (length >= 12) {
    return "#bae637";
  }
  if (length >= 8 && length <= 11) {
    return "#ffa940";
  }
  if (length <= 7) {
    return "#ff4d4f";
  }
}
